import type { TwelveMonthRevenueInsightsDTO } from "../models/twelveMonthRevenueInsightsDto";
import type { TwelveMonthRevenueInsightsEntity } from "../../domain/entities/TwelveMonthRevenueInsightsEntity";

export function twelveMonthRevenueInsightsDtoToEntity(
  dto: TwelveMonthRevenueInsightsDTO,
): TwelveMonthRevenueInsightsEntity {
  const monthCountRaw = dto.month_count;
  const monthCount =
    typeof monthCountRaw === "number" && Number.isFinite(monthCountRaw)
      ? monthCountRaw
      : 0;

  return {
    insights: (dto.insights ?? []).map((item) => ({
      accentColor: (item.accentColor ?? "neutral") as
        | "success"
        | "warning"
        | "neutral",
      description: item.description ?? "",
    })),
    rangeLabel: dto.range_label ?? "",
    monthCount,
    noInsights: dto.no_insights ?? false,
    message: dto.message ?? null,
  };
}
